// src/LevelProgress.js
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useXP } from "./XPContext";

const LevelProgress = () => {
  const { t } = useTranslation();
  const { progression, levelUpTrigger } = useXP();
  const [justLeveledUp, setJustLeveledUp] = useState(false);

  useEffect(() => {
    if (levelUpTrigger > 0) {
      setJustLeveledUp(true);
      const t = setTimeout(() => setJustLeveledUp(false), 600);
      return () => clearTimeout(t);
    }
  }, [levelUpTrigger]);
  const { level, xpInLevel, xpForNextLevel } = progression;
  const progressPercent =
    xpForNextLevel > 0
      ? Math.min(100, (xpInLevel / xpForNextLevel) * 100)
      : 0;

  return (
    <div className="level-progress">
      <div className={`level-badge ${justLeveledUp ? "level-up-highlight" : ""}`} title={t("levelTooltip", { level })}>
        <span className="level-number">Lv.{level}</span>
      </div>
      <div className="xp-bar-container">
        <div
          className="xp-bar-fill"
          style={{ width: `${progressPercent}%` }}
          role="progressbar"
          aria-valuenow={xpInLevel}
          aria-valuemin={0}
          aria-valuemax={xpForNextLevel}
        />
        <span className="xp-bar-text">
          {xpInLevel}/{xpForNextLevel} XP
        </span>
      </div>
    </div>
  );
};

export default LevelProgress;
